import {createStoreAPI} from './CreateStoreAPIService'

export const searchVariants = (productId, optionSlugs, queryOption) => {
    const api = createStoreAPI({suffix: '/product'})
    return api.makeAuthRequest({
        url: `/products/${productId}/variants/map-catalog`,
        method: 'GET',
        params: {
            options: optionSlugs,
            ...queryOption,
        },
    })
}
export const searchProductVariants = (productId, optionSlugs, queryOption = {}) => {
    const api = createStoreAPI({suffix: '/product'})
    return api.makeAuthRequest({
        url: `/products/${productId}/variants/search`,
        method: 'POST',
        data: {
            options: optionSlugs,
            ...queryOption,
        },
    })
}
